<template>
  <div class="main">
    <div :class="['top_box', 'orangeToYellow']">
      <div class="title">阀门编程</div>
      <div>编号：{{ no }}</div>
    </div>

    <div class="wrap">
      <!-- 灌溉量 -->
      <div class="module moduleA">
        <div class="com_tit">灌溉量</div>
        <div class="card month">
          <div class="row row1">
            <div class="num">1</div>
            <div class="txt">灌溉持续时间</div>
            <div class="min">
              <span><input type="number" v-model="irrigating.minute_num" /></span>
              <span>分钟</span>
            </div>
          </div>
          <div class="line"></div>
          <div class="row row2">
            <div class="num">2</div>
            <div class="txt">月的灌溉量</div>
          </div>
          <div :class="['month_box', triggle ? 'triggle_open' : 'triggle_close']">
            <div class="month_item" v-for="(item, index) in month" :key="index">
              <div class="label">{{ item.label }}</div>
              <div class="value">
                <input type="number" :min="0" :max="100" v-model="item.value" />
                %
              </div>
            </div>
          </div>
          <div :class="['triggle']" @click="handleTriggle">
            点击填写月灌溉信息
          </div>

          <div class="flex cycleDate" v-if="type == 21">
            <div class="text">日志上传周期：</div>
            <div class="time  inp" style="margin-bottom:0;">
              <van-field v-model="cycleDate" />
            </div>
            <span style="margin-left: 10px;">天</span>
          </div>
        </div>
      </div>
      <!-- 雨量传感器 -->
      <div class="module moduleB">
        <div class="top">
          <div class="com_tit">雨量传感器</div>
          <div class="switch">
            <van-switch v-model="switchRain" size="24px" active-color="#13B28C" />
          </div>
        </div>
      </div>
      <!-- 自动灌溉 -->
      <div class="module moduleC">
        <div class="top">
          <div class="com_tit">自动灌溉</div>
          <div class="switch">
            <van-switch :value="switchAuto" size="24px" active-color="#13B28C" @change="handleSwitchChange($event, 1)" />
          </div>
        </div>
        <div class="bottom card">
          <div class="row row1">
            <div class="left">灌溉时间段</div>
            <div class="right">
              <div class="time time1" @click="handleShowTimePicker(1)">
                {{ autoWork.time1 }}
              </div>
              -
              <div class="time time2" @click="handleShowTimePicker(2)">
                {{ autoWork.time2 }}
              </div>
            </div>
          </div>
          <div class="row row2">
            <div class="left">水分指导灌溉</div>
            <div class="right">
              <div class="num">
                <span>
                  <input v-model="water_potential_threshold" type="number" max="9999" min="-9999" maxlength="5" @change="handleInputChange" />
                </span>
                <span>kpa</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 定时灌溉 -->
      <div class="module moduleD">
        <div class="top">
          <div class="com_tit">定时灌溉</div>
          <div class="switch">
            <van-switch :value="switchTime" size="24px" active-color="#13B28C" @change="handleSwitchChange($event, 0)" />
          </div>
        </div>
        <div class="auto_setting card">
          <div class="part part1">
            <div class="top">1.灌溉时间</div>
            <div class="times">
              <div class="time" v-for="(item, index) in setTimes" :key="index" @click="handleShowCustomTimePicker(index)">
                <!-- 从三开始 表示是定时灌溉的 -->
                <div class="left">{{ index + 1 }}</div>
                <div class="right">{{ item == "-1:-1" ? "-:-" : item }}</div>
              </div>
            </div>
          </div>

          <div class="part part2">
            <div class="top">2.灌溉日期</div>
            <div class="odd">
              <div class="left">偶数天</div>
              <div class="right" @click="handleClickWhether">
                <div class="isOdd">{{ isOdd === "是" ? "是" : "否" }}</div>
              </div>
            </div>
          </div>

          <div class="part every_week part3">
            <div class="tit">每周灌溉</div>
            <div class="week">
              <div :class="['w_item', item.check && 'w_active']" v-for="(item, index) in week" :key="index" @click="handleClickWeek(index)">
                {{ item.label }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 保存按钮 -->
      <div class="save" @click="handleSave">
        <div class="btn">保存</div>
      </div>
    </div>

    <van-popup key="showWhetherPicker" v-model="showWhetherPicker" position="bottom" @click-overlay="handleClickWhether">
      <van-picker title="是否偶数天" show-toolbar :columns="columns" @confirm="hanleWhetherConfirm" @cancel="handleClickWhether" />
    </van-popup>

    <van-popup key="showDateTimePicker" v-model="showDateTimePicker" position="bottom" @click-overlay="handleDateTimeCancel">
      <van-datetime-picker ref="dateTimePicker" type="time" title="选择时间" :min-hour="0" :max-hour="23" @confirm="handleDateTimeChange" @cancel="handleDateTimeCancel" />
    </van-popup>

    <van-popup key="showDateTimePicker2" v-model="showCustomDateTimePicker" position="bottom" @click-overlay="handleCustomDateTimeCancel">
      <van-picker title="选择灌溉时间" show-toolbar :columns="timeColumns" @confirm="onTimeConfirm" @cancel="handleCustomDateTimeCancel" />
    </van-popup>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data () {
    return {
      no: null,
      switchValve: false, // 阀门开关
      switchGuan: false, // 灌溉开关
      switchRain: false, // 雨量开关
      switchAuto: false, // 自动开关
      switchTime: false, // 定时开关
      // 自动灌溉信息
      irrigating: {
        end_time: "00:00",
        minute_num: 0,
        start_time: "00:00"
      },
      waterGuid: 0, // 水势灌溉指导值
      isOdd: false, // 是否是基数
      week: "", // 每周几
      // 自动灌溉数据
      autoWork: {
        time1: "00:00",
        time2: "00:00",
        kpa: "0"
      },
      showDateTimePicker: false,
      auroWorkTimeIndex: null,
      water_potential_threshold: null,
      setTimes: ["00:00", "00:00", "00:00", "00:00"],
      week: [],
      month: [],
      triggle: false,
      columns: ["是", "否"],
      showWhetherPicker: false,
      showCustomDateTimePicker: false,
      timeColumns: [],
      type: null,
      cycleDate: null
    };
  },

  async mounted () {
    this.no = localStorage.getItem("no");
    this.type = sessionStorage.getItem("deviceType");

    const timeColumns = [[], []];
    const _arr = new Array(24).fill();
    const _arr2 = new Array(60).fill();

    _arr.map((o, i) => {
      timeColumns[0].push(String(i + 1).padStart(2, "0"));
    });

    _arr2.map((o, i) => {
      timeColumns[1].push(String(i + 1).padStart(2, "0"));
    });
    timeColumns[0].unshift("无");
    // timeColumns[1].unshift("无")

    this.timeColumns = [
      {
        values: [...timeColumns[0]],
        defaultIndex: 1
      },
      {
        values: [...timeColumns[1]],
        defaultIndex: 0
      }
    ];

    const arr = [1, 2, 3, 4, 5, 6, 7];
    const week = [];
    arr.map(item => {
      week.push({
        label: this.$noToChinese(item) == "七" ? "日" : this.$noToChinese(item),
        check: false
      });
    });
    this.week = [...week];
    console.log("week:", week);
    const arr2 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    const keys = [
      "jan",
      "feb",
      "mar",
      "apr",
      "may",
      "jun",
      "aug",
      "jul",
      "sep",
      "oct",
      "nov",
      "dec"
    ];
    const month = [];
    arr2.map((item, index) => {
      month.push({
        label: this.$noToChinese(item) + "月",
        value: 0,
        key: keys[index]
      });
    });
    this.month = [...month];

    if (!this.no) {
      return this.$toast({
        message: `异常：设备号不能为空`,
        duration: 3000
      });
    }

    try {
      await this.getSetting();
      await this.getValveStatus();
    } catch (err) {
      console.error("err:", err);

      this.$toast({ message: err });
    }
  },

  methods: {
    // 读取设置信息
    async getSetting () {
      this.$toast.loading({
        message: this.$t("live.read_loading"),
        forbidClick: true,
        duration: 0
      });
      let apiStr = "rtu_getSetting";
      if (this.type == 21) {
        apiStr = "getGuanGaiKongZhiConfig";
      }

      await this.$api[apiStr](this.no).then(res => {
        if (res.errcode !== 0) {
          return this.$toast({
            message: `读取设置异常:${res.errmsg}`,
            duration: 5000
          });
        }

        if (!res || !res.data) {
          return this.$toast({ message: "res 没值" });
        }

        const week_cron =
          this.type == 21 ? res?.data?.weekCron : res?.data?.week_cron;
        const irrigate_per =
          this.type == 21 ? res?.data?.irrigationPer : res?.data?.irrigate_per;
        const irrigating = this.type == 21 ? {} : res?.data?.irrigating;
        const rainfall_state =
          this.type == 21
            ? res?.data?.rainfallState
            : res?.data?.rainfall_state;
        const water_potential_threshold =
          this.type == 21
            ? res?.data?.waterPotentialThreshold
            : res?.data?.water_potential_threshold;
        const water_potential_switch =
          this.type == 21
            ? res?.data?.waterPotentialSwitch
            : res?.data?.water_potential_switch;
        const timing_switch =
          this.type == 21 ? res?.data?.timingSwitch : res?.data?.timing_switch;

        const cronArr = week_cron.split("");
        const first = cronArr[0];

        console.log("first:", first);
        if (first == 1) {
          this.isOdd = "是";
        } else {
          this.isOdd = "否";
        }

        cronArr.splice(0, 1);

        cronArr.map((o, i) => {
          if (o == 1) {
            this.week[i].check = true;
          } else {
            this.week[i].check = false;
          }
        });

        const month = [...this.month];

        console.log("month:", month, irrigate_per);
        month.map((o, i) => {
          console.log("o:", o);
          o.value = irrigate_per[o.key];
        });

        let setTimes = [];
        if (this.type == 21) {
          this.setTimes.map((o, i) => {
            setTimes.push(res.data?.startTimes[i]?.startTime);
          });
        } else {
          this.setTimes.map((o, i) => {
            setTimes.push(res.data[`start_time_${i + 1}`]?.time);
          });
        }
        this.setTimes = [...setTimes];

        console.log("123:", this.setTimes);
        this.switchAuto = water_potential_switch; //水势开关
        this.switchTime = timing_switch; //定时开关
        this.month = [...month];
        this.water_potential_threshold = water_potential_threshold;
        this.cycleDate = res.data?.cycleDate;
        this.switchRain = rainfall_state;
        this.waterGuid = water_potential_threshold;

        if (this.type == 21) {
          this.irrigating = {
            minute_num: res.data?.minuteNum,
            start_time: res.data?.startTime || "00:00",
            end_time: res.data?.endTime || "00:00"
          };

          this.autoWork.time1 = res.data?.startTime || "00:00";
          this.autoWork.time2 = res.data?.endTime || "00:00";
        } else {
          this.irrigating = { ...res.data?.irrigating };

          this.autoWork.time1 = irrigating.start_time;
          this.autoWork.time2 = irrigating.end_time;
        }
      });
    },

    // 读取程序执行状态
    async getValveStatus () {
      this.$toast.loading({
        message: this.$t("live.read_loading"),
        forbidClick: true,
        duration: 0
      });

      let apiStr = "rtu_getValveStatus";
      if (this.type == 21) {
        apiStr = "getGuanGaiKongZhiQiReadValveStatus";
      }

      await this.$api[apiStr]({ gatewayNo: this.no }).then(res => {
        if (res.errcode !== 0) {
          return this.$toast({
            message: `读取状态异常:${res.errmsg}`,
            duration: 5000
          });
        }

        const valve_status =
          this.type == 21 ? res.data?.valveStatus : res.data?.valve_status;
        this.switchValve = valve_status;
        this.$toast.clear();
      });
    },

    handleTriggle () {
      this.triggle = !this.triggle;
    },

    handleShowTimePicker (index) {
      this.auroWorkTimeIndex = index;
      this.showDateTimePicker = true;
    },

    handleShowCustomTimePicker (index) {
      this.auroWorkTimeIndex = index;
      this.showCustomDateTimePicker = true;
    },

    handleDateTimeChange (val) {
      if (this.auroWorkTimeIndex < 3) {
        this.autoWork[`time${this.auroWorkTimeIndex}`] = val;

        console.log("this.autoWork:", val, this.autoWork);
      } else {
        this.setTimes[this.auroWorkTimeIndex - 3] = val;
      }

      this.handleDateTimeCancel();
    },

    handleDateTimeCancel () {
      console.log("取消");
      this.showDateTimePicker = false;
    },

    handleCustomDateTimeCancel () {
      this.showCustomDateTimePicker = false;
    },

    handleInputChange (e) {
      console.log(e);
      this.autoWork.kpa = e.target.value;
      console.log(this.autoWork.kpa);
    },

    handleClickWhether () {
      this.showWhetherPicker = !this.showWhetherPicker;
    },

    hanleWhetherConfirm (val) {
      this.isOdd = val;
      this.handleClickWhether();
    },

    handleClickWeek (index) {
      this.week[index].check = !this.week[index].check;
    },

    onTimeConfirm (value) {
      if (value[0] === "无") {
        this.setTimes[this.auroWorkTimeIndex] = "无";
      } else {
        this.setTimes[this.auroWorkTimeIndex] = value.join(":");
      }
      this.handleCustomDateTimeCancel();
    },

    // 自动灌溉 和 定时灌溉的开关切换事件
    handleSwitchChange (state, index) {
      const keys = ["switchAuto", "switchTime"];
      if (state && this[keys[index]]) {
        this.$toast({
          message: "自动灌溉和定时灌溉不能同时开启"
        });
      }
      const i1 = index + 1 > 1 ? 0 : 1;
      const i2 = index - 1 < 0 ? 0 : 1;
      this[keys[i1]] = state;
      if (state) {
        this[keys[i2]] = !state;
      }
    },

    // 保存
    async handleSave () {
      await this.$toast.loading({
        message: this.$t("加载中..."),
        forbidClick: true,
        duration: 0
      });

      // 校验
      // 灌溉时长不能为0
      if (this.irrigating.minute_num < 1) {
        return this.$toast.fail("灌溉时长不能为小于1");
      }

      const keys = [
        "jan",
        "feb",
        "mar",
        "apr",
        "may",
        "jun",
        "aug",
        "jul",
        "sep",
        "oct",
        "nov",
        "dec"
      ];

      const irrigation_per = {};
      this.month.map((o, i) => {
        irrigation_per[keys[i]] = o;
      });

      const start_times = [];
      this.setTimes.map(o => {
        if (o == "00:00" || o == "0:0" || o.indexOf("-1") > -1 || o == "无") {
        } else {
          start_times.push({
            start_time: o,
            duration: this.irrigating.minute_num
          });
        }
      });

      let week_cron = ["0", "0", "0", "0", "0", "0", "0"];
      const week = [...this.week];
      week.map((o, i) => {
        if (o.check) {
          week_cron[i] = "1";
        } else {
          week_cron[i] = "0";
        }
      });

      const obj = {};
      Object.keys(irrigation_per).map(
        key => (obj[key] = Number(irrigation_per[key].value))
      );

      console.log("this.isOdd:", this.isOdd);

      if (this.isOdd === "是") {
        week_cron.unshift("1");
      } else {
        week_cron.unshift("0");
      }

      let gateway_no_key = this.type == 21 ? "gatewayNo" : "gateway_no";
      let system_time_key = this.type == 21 ? "systemTime" : "system_time";
      let water_potential_threshold_key = this.type == 21 ? "waterPotentialThreshold" : "water_potential_threshold";
      let rainfall_state_key = this.type == 21 ? "rainfallState" : "rainfall_state";
      let start_time_key = this.type == 21 ? "startTime" : "start_time";
      let end_time_key = this.type == 21 ? "endTime" : "end_time";
      let minute_num_key = this.type == 21 ? "minuteNum" : "minute_num";
      let water_potential_switch_key = this.type == 21 ? "waterPotentialSwitch" : "water_potential_switch";
      let timing_switch_key = this.type == 21 ? "timingSwitch" : "timing_switch";
      let irrigation_per_key = this.type == 21 ? "irrigationPer" : "irrigation_per";
      let week_cron_key = this.type == 21 ? "weekCron" : "week_cron";
      let start_times_key = this.type == 21 ? "startTimes" : "start_times";

      const params = {
        [gateway_no_key]: this.no,
        [system_time_key]: moment().format("YYYY-MM-DD HH:mm"), // TODO 这里的时间哪里来
        [irrigation_per_key]: obj,
        [water_potential_threshold_key]: this.water_potential_threshold || 0, // 水势灌溉时长 分
        [start_times_key]: start_times,
        [rainfall_state_key]: this.switchRain, // 雨量开关
        [start_time_key]: this.autoWork.time1,
        [end_time_key]: this.autoWork.time2,
        [minute_num_key]: this.irrigating.minute_num,
        [week_cron_key]: week_cron.join(""), //定时任务时间 最低位为星期1 置1 为当天生效;1000 0000设置为偶数天
        [water_potential_switch_key]: this.switchAuto, //水势开关
        [timing_switch_key]: this.switchTime //定时开关
      };

      if (this.type == 21) {
        params.cycleDate = this.cycleDate;
      } else {
        params.cycleDate = "999";
      }

      console.log("week:", week_cron);

      let apiStr = "rtu_setting";
      if (this.type == 21) {
        apiStr = "setGuanGaiKongZhiQiConfig";
      }

      console.log("params:", params);

      await this.$api[apiStr](params).then(res => {
        if (res.errcode !== 0) {
          return this.$toast({ message: `设置异常:${res.errmsg}`, duration: 5000 });
        }

        this.$toast.success({ message: `设置成功` });

        setTimeout(() => {
          return this.$router.back();
        }, 1500);

        this.$toast.clear();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.main {
  height: 100%;
  background: #f0f5fc;
  font-size: 16px;
}

.top_box {
  height: 80px !important;
  color: #ffffff;
  font-size: 16px !important;
  padding: 10px;
  box-sizing: border-box;

  > .title {
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 10px;
  }
}

.wrap {
  padding: 18px;
}

.module {
  .top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 18px;

    .switch {
      display: flex;
      align-items: center;
    }
  }
}

.com_tit {
  display: flex;
  align-items: center;
  color: #464646;
  font-size: 18px;

  &::before {
    display: table;
    content: " ";
    width: 6px;
    height: 16px;
    background: linear-gradient(180deg, #56a0fb 0%, #3776f6 100%);
    border-radius: 20px;
    margin-right: 8px;
  }
}

.card {
  background: #ffffff;
  box-shadow: 0px 10.46px 30.43px rgba(57, 129, 246, 0.05);
  border-radius: 8px;
  padding: 13px 15px;
  margin-bottom: 20px;
}

.row {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .left {
    color: #6f7ea8;
  }

  .right {
    display: flex;
    align-items: center;

    .time {
      width: 84px;
      height: 27px;
      line-height: 27px;
      text-align: center;
      background: #ffffff;
      border: 0.4px solid #a9b2cb;
      border-radius: 5px;
      // padding: 5px 10px;
    }

    .time1 {
      margin-right: 6px;
    }
    .time2 {
      margin-left: 6px;
    }

    .num {
      display: flex;
      justify-content: space-between;
      width: 187px;
      text-align: center;
      background: #ffffff;
      border: 0.4px solid #a9b2cb;
      border-radius: 5px;
      height: 27px;
      line-height: 27px;

      span {
        flex: 1;
        text-align: right;
      }

      span:last-child {
        text-align: left;
      }

      span:last-child::before {
        display: inline-block;
        content: " ";
        width: 6px;
      }

      input {
        width: 100%;
        text-align: right;
        border-radius: 10px;
      }
    }
  }
}

.row1 {
  margin-bottom: 14px;
}

.auto_setting {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  box-sizing: border-box;

  .top {
    margin-bottom: 12px;
  }

  .part {
    width: 100%;
  }

  .times {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
    flex: 1;

    .left {
      flex: 1;
    }

    .right {
      flex: 1;
      text-align: center;
    }

    .time {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 48%;
      height: 40px;
      border: 0.4px solid #6f7ea8;
      border-radius: 5px;
      text-align: center;
      margin-bottom: 12px;
      overflow: hidden;
    }
  }

  .part2 {
    border-bottom: 0.4px solid rgba(111, 126, 168, 0.6);
    padding-bottom: 14px;

    .odd {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .left {
      color: #6f7ea8;
    }

    .right {
      .isOdd {
        width: 110px;
        height: 27px;
        border: 0.4px solid #6f7ea8;
        border-radius: 5px;
        text-align: center;
      }
    }
  }

  .every_week {
    margin-top: 12px;

    .tit {
      color: #6f7ea8;
      margin-bottom: 12px;
    }

    .week {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .w_item {
      width: 36px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      background: #ffffff;
      border: 0.454147px solid #bdbdbd;
      border-radius: 4.54147px;
      color: #bdbdbd;
    }

    .w_active {
      background: #1e98f6;
      color: #ffffff;
    }
  }
}

.save {
  width: 100%;
  padding: 0 18px;
  box-sizing: border-box;

  .btn {
    width: 100%;
    height: 48px;
    line-height: 48px;
    background: linear-gradient(90deg, #4877e9 0%, #194cc9 100.97%);
    border-radius: 30px;
    text-align: center;
    color: #ffffff;
  }
}

.month {
  position: relative;
  margin-top: 15px;

  .row {
    justify-content: inherit;
  }

  .row1 {
    display: flex;
  }

  .num {
    width: 24px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    color: #464646;
    background: #eef6fa;
    border-radius: 6.44918px;
    margin-right: 8px;
  }

  .min {
    display: flex;
    justify-content: space-between;
    width: 110px;
    text-align: center;
    background: #ffffff;
    border: 0.4px solid #a9b2cb;
    border-radius: 5px;
    height: 27px;
    line-height: 27px;

    span {
      flex: 1;
      text-align: right;
    }

    span:last-child {
      text-align: left;
    }

    span:last-child::before {
      display: inline-block;
      content: " ";
      width: 6px;
    }

    input {
      width: 90%;
      text-align: right;
      border-radius: 10px;
      margin-right: 5px;
    }
  }

  .txt {
    color: #6f7ea8;
    font-size: 16px;
    margin-right: 70px;
  }

  .line {
    position: absolute;
    top: 37px;
    left: 26px;
    width: 1px;
    height: 18px;
    background: #6f7ea8;
  }
}
.month_box {
  padding-top: 15px;

  .month_item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 35px;
    border-bottom: 0.4px solid rgba(111, 126, 168, 0.6);
  }

  input {
    text-align: right;
  }
}
.triggle {
  width: 100%;
  text-align: center;
  font-size: 12px;
  color: #bdbdbd;
  margin-top: 12px;
}

.triggle_close {
  max-height: 72px;
  overflow: hidden;
}

.triggle_open {
  max-height: auto;
  // overflow: hidden;
}

.cycleDate {
  display: flex;
  align-items: center;
  background: #ffffff;
  z-index: 9;
  padding: 10px;
  box-shadow: 0px 10.46px 30.43px rgba(57, 129, 246, 0.05);

  .time {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 48%;
    height: 40px;
    border: 0.4px solid #6f7ea8;
    border-radius: 5px;
    text-align: center;
    margin-bottom: 12px;
    overflow: hidden;
  }
}
</style>
